import { Dialog as StyledDialog } from './Dialog.styled';
import { DialogProps } from './Dialog.types';

export function Dialog(props: DialogProps) {
  return (
    <StyledDialog
      {...props}
      PaperProps={{
        ['aria-modal']: true,
        ...props.PaperProps,
      }}
    />
  );
}
